if (window.innerWidth < 1025) {
  var swiper = new Swiper(
    ".block_tab-collection-for-you .block_mobproduct_full",
    {
      slidesPerView: 1,
      grid: {
        rows: 3,
      },
      freeMode: {
          enabled: true,
          momentumBounce: false,
        },
      observer: true,
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-for-you .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
    }
  );

  var swiper = new Swiper(
    ".block_tab-collection-for-you .block_mobtab-slider",
    {
      slidesPerView: 4,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      scrollbar: {
        el: ".block_tab-collection-for-you .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        575: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    }
  );

  var swiper = new Swiper(
    ".block_tab-collection-for-you .block_mobtab-slider-featured",
    {
      slidesPerView: 4,
      spaceBetween: 20,
      observer: true,
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-for-you .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        280: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        560: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        860: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    }
  );

  var swiper = new Swiper(
    ".block_tab-collection-for-you .block_mobtab-slider-full",
    {
      slidesPerView: 4.136,
      spaceBetween: 20,
      observer: true,
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-for-you .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        280: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
         375: {
          slidesPerView: 1.25,
          spaceBetween: 10,
        },
        400: {
          slidesPerView: 1.45,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1.8,
          spaceBetween: 10,
        },
        680: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        920: {
          slidesPerView: 3.136,
          spaceBetween: 10,
        },
      },
    }
  );
} else {
  var swiper = new Swiper(".block_tab-collection-for-you .block_product_full", {
    slidesPerView: 1,
    grid: {
      rows: 3,
    },
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".block_tab-collection-for-you .block_slider-right-arrow",
      prevEl: ".block_tab-collection-for-you .block_slider-left-arrow ",
    },
    observer: true,
    observeParents: true,
    scrollbar: {
      el: ".block_tab-collection-for-you .swiper-scrollbar",
      draggable: true,
      hide: false,
    },
  });

  var swiper = new Swiper(".block_tab-collection-for-you  .block_tab-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    observer: true,
    mousewheel: {
      forceToAxis: true,
    },
    observeParents: true,
    scrollbar: {
      el: ".block_tab-collection-for-you .swiper-scrollbar",
      draggable: true,
      hide: false,
    },
    navigation: {
      nextEl: ".block_tab-collection-for-you .block_slider-right-arrow",
      prevEl: ".block_tab-collection-for-you .block_slider-left-arrow ",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 4,
      },
    },
  });

  var swiper = new Swiper(
    ".block_tab-collection-for-you .block_tab-slider-full",
    {
      slidesPerView: 4.136,
      spaceBetween: 20,
      observer: true,
      mousewheel: {
        forceToAxis: true,
      },
      observeParents: true,
      scrollbar: {
        el: ".block_tab-collection-for-you .swiper-scrollbar",
        draggable: true,
        hide: false,
      },
      navigation: {
        nextEl: ".block_tab-collection-for-you .block_slider-right-arrow",
        prevEl: ".block_tab-collection-for-you .block_slider-left-arrow ",
      },
      breakpoints: {
        1025: {
          slidesPerView: 3.2,
          spaceBetween: 10,
        },
        1366: {
          slidesPerView: 3.5,
          spaceBetween: 10,
        },
        1500: {
          slidesPerView: 4.6,
        },
      },
    }
  );
}
